export function isProfileMan(type) {
    return type === 'man';
}
